import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { FaStar } from 'react-icons/fa';
import { toast } from 'react-toastify';
import useApi from '../../hooks/useApi';
import Alert from '../common/Alert';

function RateHelper({ helper, onClose, onSubmit }) {
  const { session } = useContext(AuthContext);
  const { userId } = session || { userId: null };
  const { post, get } = useApi();
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    // Fetch existing rating for the user and helper
    const fetchExistingRating = async () => {
      try {
        const response = await get(`/api/domestic-helpers/${helper.id}/ratings/user/${userId}`);
        if (response && response.rating) {
          setRating(response.rating);
        }
      } catch (err) {
        console.error('RateHelper - Fetch existing rating error:', err);
        // Ignore errors if no rating exists
      }
    };

    if (userId && helper.id) {
      fetchExistingRating();
    }
  }, [userId, helper.id, get]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating < 1 || rating > 5) {
      setError('Please select a rating between 1 and 5 stars.');
      toast.error('Please select a rating between 1 and 5 stars.');
      return;
    }

    try {
      await post(`/api/domestic-helpers/${helper.id}/ratings`, { rating });
      toast.success(rating === helper.rating ? 'Rating updated successfully' : 'Rating submitted successfully');
      onSubmit();
    } catch (err) {
      console.error('RateHelper - Submit error:', err);
      const errorMessage = err.response?.data?.message || 'Failed to submit rating.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content shadow">
          <div className="modal-header">
            <h5 className="modal-title">Rate {helper.name}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {error && <Alert type="danger" message={error} />}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Your Rating</label>
                <div className="d-flex justify-content-center">
                  {[...Array(5)].map((_, index) => {
                    const ratingValue = index + 1;
                    return (
                      <label key={index} className="mx-1">
                        <input
                          type="radio"
                          name="rating"
                          value={ratingValue}
                          onClick={() => setRating(ratingValue)}
                          style={{ display: 'none' }}
                        />
                        <FaStar
                          size={30}
                          color={ratingValue <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
                          onMouseEnter={() => setHover(ratingValue)}
                          onMouseLeave={() => setHover(null)}
                          style={{ cursor: 'pointer' }}
                        />
                      </label>
                    );
                  })}
                </div>
              </div>
              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-primary flex-grow-1">
                  {rating > 0 ? 'Update Rating' : 'Submit Rating'}
                </button>
                <button type="button" className="btn btn-secondary flex-grow-1" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RateHelper;